<template>
  <div class="bg-white" style="padding: 15px">
    <el-row>
      <el-col :span="24" :md="{ span: 8 }">
        <el-button
          type="primary"
          size="small"
          @click="createNew"
          v-if="user.isRole([1, 4])"
        >
          Add ULD
        </el-button>
        <AddForm ref="addForm" />
      </el-col>
      <el-col :span="24" :md="{ span: 8, offset: 8 }">
        <el-form label-position="left">
          <el-form-item>
            <el-input
              type="text"
              v-model="searchKey"
              placeholder="Search Job Order No."
              @keydown.native.enter.prevent="fetch(1)"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click.prevent="fetch(1)"
              >
              </el-button>
            </el-input>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table
          :data="list.data"
          v-loading="isLoading"
        >
          <el-table-column label="Actions" width="100">
            <template slot-scope="scope">
              <el-button
                type="primary"
                icon="el-icon-edit"
                title="Update Job Order"
                circle
                size="small"
                @click="edit(scope.row)"
              ></el-button>
              <el-button
                size="small"
                type="danger"
                icon="el-icon-delete"
                @click="removeULDOut(scope.row.uld_out.id)"
                title="Remove this item in ULD out. "
                circle
                v-if="scope.row.uld_out"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="Job Order No."
            prop="job_order_number"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.job_order_number }}</span>
            </template>
          </el-table-column>
          <el-table-column
            min-width="100px"
            label="Date Received"
            prop="date_received"
          >
            <template slot-scope="scope">{{
              scope.row.date_received | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            min-width="150px"
            label="ULD ID Code"
            prop="masterlist.uld_id_code"
          ></el-table-column>
          <el-table-column
            min-width="150px"
            label="Status"
            prop="status.name"
          ></el-table-column>
          <el-table-column
            min-width="100px"
            label="Job Completed"
            prop="job_completed"
          >
            <template slot-scope="scope">{{
              scope.row.job_completed | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            min-width="150px"
            label="Mechanic"
            prop="mechanic.username"
          ></el-table-column>
          <el-table-column
            min-width="150px"
            label="Supervisor"
            prop="supervisor.username"
          ></el-table-column>
          <!-- <el-table-column label="Labor" prop="labor"></el-table-column> -->
          <!-- <el-table-column label="Materials" prop="materials"></el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row class="mt-1">
      <el-col :sm="12">
        <el-pagination
          class="pt-1 pb-1"
          background
          layout="prev, pager, next"
          :total="list.paging.total"
          :page-size="pager.limit"
          :current-page="parseInt(list.paging.cur_page)"
          @current-change="fetch"
        ></el-pagination>
      </el-col>
      <el-col class="text-right" :sm="12">
        <!-- <el-button type="primary" @click="download">Download</el-button>
        <el-button class="ml-2" type="primary" @click="downloadBER"
          >Download BER Report</el-button
        > -->
        <template v-if="user.isRole([1, 2, 4])">
          <el-dropdown
            split-button
            type="primary"
            @click="openULD"
            @command="commandSelect"
          >
            Download Report
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="BER"
                >Download BER Report</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-col>
    </el-row>
    <app-drawer ref="berDrawer" title="BER Report Filter">
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form label-position="top">
          <el-form-item label="Customer">
            <el-select v-model="berFilter.customer_id" clearable filterable>
              <el-option
                v-for="c in customers"
                :key="c.value"
                :value="c.value"
                :label="c.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Date Received">
            <el-date-picker
              v-model="berFilter.dateRange"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="downloadBER">Download</el-button>
        </div>
      </div>
    </app-drawer>
    <app-drawer ref="uldDrawer" title="ULD Report Filter">
      <div class="el-drawer__content" v-loading="isLoading">
        <el-form label-position="top">
          <el-form-item label="Customer">
            <el-select v-model="uldFilter.customer_id" clearable filterable>
              <el-option
                v-for="c in customers"
                :key="c.value"
                :value="c.value"
                :label="c.text"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Date Received">
            <el-date-picker
              v-model="uldFilter.dateRange"
              type="daterange"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="el-drawer__footer">
          <el-button type="primary" @click="download">Download</el-button>
        </div>
      </div>
    </app-drawer>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/api";
import { isMobile } from "mobile-device-detect";
import AddForm from "./addForm.vue";
import ULD from "@/models/ULD";

export default {
  name: "ULD_List",
  components: { AddForm },

  data() {
    return {
      isLoading: false,
      searchKey: "",
      pager: { limit: 15 },
      isMobile,
      sort: {
        column: "id",
        order: ""
      },
      berFilter: {
        dateRange: [],
        customer_id: ""
      },
      uldFilter: {
        dateRange: [],
        customer_id: ""
      },
      customers: []
    };
  },
  computed: {
    list() {
      return this.$store.getters["uld/list"];
      // return { paging: { test: true }, data: [] };
    },
    user() {
      return this.$store.getters["auth/user"];
    }
  },
  methods: {
    removeULDOut(id) {
      this.$confirm("This item will permanently delete to ULD out. Are you sure want to delete? ", {
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      })
        .then(() => {
          this.isLoading = true;
          this.$store.dispatch("uld/delete", id).then(resp => {
            console.log("resp.code", resp.code)
            if (resp.code != 200)
              this.$notify({
                type: "danger",
                message: "Delete failed.",
                position: "bottom-right"
              });
            else
              this.$notify({
                type: "success",
                message: "Deleted successfully.",
                position: "bottom-right"
              });
            this.isLoading = false;
          });
        })
        .catch(() => {});
    },
    createNew() {
      this.$refs.addForm.open();
    },
    fetch(page) {
      this.isLoading = true;
      let payload = { ...this.pager, user_type: this.user.user_type };
      payload.page = 1;
      if (page) {
        payload.page = page;
      }

      let search = null;
      if (this.searchKey) {
        if (this.searchKey.includes("-")) {
          let s = this.searchKey.split("-");
          search = s[1];
        } else {
          search = this.searchKey;
        }
        payload.id = parseInt(search);
      }

      if (this.sort) {
        payload.order_by = this.sort.order + this.sort.column;
      }
      payload.is_index = 1;
      this.$store.dispatch("uld/fetchList", payload).then(() => {
        this.isLoading = false;
      });
    },
    edit(uld) {
      this.$router.push({ name: "repairULD_info", params: { id: uld.id } });
    },
    commandSelect(command) {
      if (command == "BER") this.$refs.berDrawer.open();
    },
    openULD() {
      this.$refs.uldDrawer.open();
    },
    download() {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `ULD Report ${d}`,
        ext: ".csv"
      };
      this.isLoading = true;
      let params = {};
      if (this.uldFilter.dateRange && this.uldFilter.dateRange[0]) {
        params.date_received_from = moment(this.uldFilter.dateRange[0]).format(
          "YYYY-MM-DD"
        );
        params.date_received_to = moment(this.uldFilter.dateRange[1]).format(
          "YYYY-MM-DD"
        );
        params.date_received = 1;
      }
      if (this.uldFilter.customer_id) {
        params.per_customer_id = this.uldFilter.customer_id;
      }
      api
        .download(`/api/v1/repair/uld/?is_uld_report=1`, reportInfo, params)
        .then(() => {
          this.isLoading = false;
        });
    },
    downloadBER() {
      var d = moment().format("MM-DD-YYYY");
      var reportInfo = {
        name: `ULD Ber Report ${d}`,
        ext: ".csv"
      };
      let params = {};
      if (this.berFilter.dateRange && this.berFilter.dateRange[0]) {
        params.date_received_from = moment(this.berFilter.dateRange[0]).format(
          "YYYY-MM-DD"
        );
        params.date_received_to = moment(this.berFilter.dateRange[1]).format(
          "YYYY-MM-DD"
        );
      }
      if (this.berFilter.customer_id) {
        params.per_customer_id = this.berFilter.customer_id;
      }
      this.isLoading = true;
      api
        .download(`/api/v1/repair/uld/?is_ber_report=1`, reportInfo, params)
        .then(() => {
          this.isLoading = false;
        });
    },
    sortChange(sortProps) {
      if (sortProps) {
        this.sort.order =
          sortProps.order == "ascending" || sortProps.order == null ? "" : "-";
        switch (sortProps.prop) {
          case "job_order_number":
            this.sort.column = "id";
            break;
          case "masterlist.uld_id_code":
            this.sort.column = "masterlist_id__uld_id_code";
            break;
          case "date_received":
            this.sort.column = "date_received";
            break;
        }
      }
      // console.log("ordering", sortProps);
      this.fetch(1);
    }
  },
  mounted() {
    if(this.user.isRole(3)) { 
      this.sortChange({ prop: "job_order_number", order: "ascending" });
    }
    ULD.customers_data().then(resp => {
      this.customers = resp;
    });
  }
};
</script>

<style lang="css" scoped></style>
